<template>
  <auth-layout>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="9">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Stalis MIS</v-toolbar-title>
              <v-spacer />
              <v-icon>mdi-bank</v-icon>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  Create a business owner account
                  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="user.name"
                          :rules="inputRules"
                          label="Name"
                          name="name"
                          type="text"
                        />
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="user.email"
                          :rules="inputRules"
                          label="Email"
                          name="email"
                          type="text"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="user.phone"
                          :rules="inputRules"
                          label="Phone"
                          name="phone"
                          type="text"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          label="Password"
                          name="password"
                          v-model="user.password"
                          autocomplete="on"
                          prepend-icon="mdi-lock"
                          :rules="passwordRules"
                          :append-icon="
                            showPassword ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          :type="showPassword ? 'text' : 'password'"
                          @click:append="showPassword = !showPassword"
                        />
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          label="Confirm Password"
                          name="confirmPassword"
                          v-model="confirmPassword"
                          autocomplete="on"
                          prepend-icon="mdi-lock"
                          :rules="passwordRules"
                          :append-icon="
                            showPasswordTwo ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          :type="showPasswordTwo ? 'text' : 'password'"
                          @click:append="showPasswordTwo = !showPasswordTwo"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-btn
                        color="primary"
                        class="right"
                        @click="register"
                        :loading="loader"
                        >Register</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn color="accent" to="/login" text>Or Login</v-btn>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <!-- start of snackbar -->
      <snackbar ref="snackbar"></snackbar>
      <!-- end of snackbar -->
    </v-container>
  </auth-layout>
</template>


<script>
export default {
  data: () => ({
    valid: false,
    lazy: false,
    loader: false,
    user: {},
    confirmPassword: null,
    inputRules: [(v) => !!v || "Required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    passwordRules: [
      (v) => !!v || "Required",
      (v) =>
        (v && v.length >= 5) || "Password must be greater than 4 characters",
    ],
    showPassword: false,
    showPasswordTwo: false,
  }),
  methods: {
    setUser() {
      this.user.name = "Demo";
      this.user.email = "demo@gmail.com";
      this.user.phone = "0700000000";
      this.user.password = "tech@2024#";
      this.confirmPassword = "tech@2024#";
    },
    register() {
      if (this.$refs.form.validate()) {
        if (this.user.password !== this.confirmPassword) {
          this.$refs.snackbar.show("Password mismatch!", "red");
        } else {
          const url = "/register";
          this.user.stores = [];
          const data = this.user;
          data.trial_until = "2025-01-01 00:00:00";
          data.userType = 3;
          this.loader = true;
          const self = this;
          this.$store
            .dispatch("post", { url, data })
            .then((res) => {
              if (res.ResultCode == 1200) {
                localStorage.clear();
                localStorage.setItem("token", res.ResponseData.authToken);
                localStorage.setItem("userRole", res.ResponseData.role);
                localStorage.setItem("user_id", res.ResponseData.subscriber_id);
                localStorage.setItem("subscriber_id", res.ResponseData.subscriber_id);
                localStorage.setItem("userName", res.ResponseData.name);
                self.loader = false;
               self.$router.push("/onboarding");
            //  self.$router.push("/switch-company");
              } else {
                self.loader = false;
                this.$refs.snackbar.show(res.ResultDesc, "red");
              }
            })
            .catch((err) => {
              self.loader = false;
              this.$refs.snackbar.show(err, "red");
            });
        }
      }
    },
  },
  created() {
    this.setUser();
  }
};
</script>
